var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import dayjs from 'dayjs';
import BaseApiClient from '@/plugins/apis/base-api-client';
/**
 * Timeline API window: calendar month of `reference` plus three months before and
 * two months after (six months total, inclusive). `start_time` / `end_time` are
 * `YYYY-MM` (no day).
 */
export function getMemberAllocationTimelineTimeRange(reference) {
    var anchor = reference === undefined || reference === null
        ? dayjs()
        : dayjs(reference);
    var start = anchor.startOf('month').subtract(3, 'month');
    var end = anchor.endOf('month').add(2, 'month');
    var startMonth = start.format('YYYY-MM');
    var endMonth = end.format('YYYY-MM');
    return {
        start_month: startMonth,
        end_month: endMonth,
        rangeKey: startMonth + "_" + endMonth
    };
}
var MemberAllocationApiClient = /** @class */ (function (_super) {
    __extends(MemberAllocationApiClient, _super);
    function MemberAllocationApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MemberAllocationApiClient.prototype.fetchTimeline = function (companyId, params) {
        var url = "/companies/" + companyId + "/member_large_processes_timeline";
        var _a = getMemberAllocationTimelineTimeRange(params.timelineReference), start_month = _a.start_month, end_month = _a.end_month;
        return this.client.get(url, {
            params: {
                start_month: start_month,
                end_month: end_month,
                user_offset: params.user_offset,
                user_limit: params.user_limit
            }
        });
    };
    MemberAllocationApiClient.prototype.updateUsersOrder = function (companyId, data) {
        var url = "/companies/" + companyId + "/member_users_order";
        return this.client.patch(url, data);
    };
    MemberAllocationApiClient.prototype.fetchProjectList = function (params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/active_projects_on_date";
        return client.get(url, { params: params });
    };
    MemberAllocationApiClient.prototype.fetchProcessList = function (projectId, params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/projects/" + projectId + "/active_large_processes_on_date";
        return client.get(url, { params: params });
    };
    MemberAllocationApiClient.prototype.fetchConflictTime = function (params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/large_process_time_conflicts";
        return client.get(url, { params: params });
    };
    MemberAllocationApiClient.prototype.fetchMemberConflicts = function (params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/large_process_member_conflicts";
        return client.get(url, { params: params });
    };
    MemberAllocationApiClient.prototype.assignMemberAllocation = function (params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/assign_user_to_large_process";
        return client.post(url, params);
    };
    MemberAllocationApiClient.prototype.updateAssignMemberAllocation = function (params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/reassign_user_large_process";
        return client.patch(url, params);
    };
    MemberAllocationApiClient.prototype.unassignMemberAllocation = function (params) {
        var _a = this, companyId = _a.companyId, client = _a.client;
        var url = "/companies/" + companyId + "/unassign_user_large_process";
        return client.delete(url, {
            params: params
        });
    };
    MemberAllocationApiClient.prototype.assignFullSchedule = function (params) {
        var url = "/companies/" + this.companyId + "/assign_user_to_large_process_full_schedule";
        return this.client.post(url, params);
    };
    return MemberAllocationApiClient;
}(BaseApiClient));
export default new MemberAllocationApiClient();
